import React from 'react';
import { Text, View } from '@react-pdf/renderer';

import {
  CONTRACT_COPY_OF_INSPECTION,
  CONTRACT_INSPECTION_CONTINGENCY,
  CONTRACT_INSPECTION_PRESENCE_OPTION,
  CONTRACT_INSPECTION_TYPE,
} from '@/config/constants';
import { Contract } from '@/types/ContractType';
import AdditionalInspection from '../../Components/HomeInspection/AdditionalInspection';
import GeneralInspection from '../../Components/HomeInspection/generalinspection';
import { styles } from '../style';

const HomeInspection = ({
  contract,
  inspectionType,
  inspectionContingency,
}: {
  contract: Contract;
  inspectionType: CONTRACT_INSPECTION_TYPE;
  inspectionContingency?: CONTRACT_INSPECTION_CONTINGENCY;
}) => {
  const tpi = contract?.thirdPartyInspection as any;
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Home Inspection Contingency</Text>
      {inspectionType !== CONTRACT_INSPECTION_TYPE.NOT_SELECTED &&
        inspectionContingency &&
        inspectionContingency !==
          CONTRACT_INSPECTION_CONTINGENCY.NOT_SELECTED && (
          <View style={styles.list}>
            <Text style={styles.listItem}>
              <Text style={styles.bold}>
                Post-Inspection Negotiation Rights:
              </Text>{' '}
              {inspectionContingency ===
              CONTRACT_INSPECTION_CONTINGENCY.RESERVE_THE_RIGHT
                ? 'Buyer reserves the right to negotiate price post inspection.'
                : inspectionContingency ===
                  CONTRACT_INSPECTION_CONTINGENCY.WAIVE_THR_RIGHT
                ? 'Buyer waives the right to negotiate price post inspection.'
                : ''}
            </Text>
          </View>
        )}

      {inspectionType !== CONTRACT_INSPECTION_TYPE.NOT_SELECTED && (
        <View style={styles.list}>
          {tpi?.copyOfInspection ===
            CONTRACT_COPY_OF_INSPECTION.PROVIDE_FULL_COPY && (
            <Text style={styles.listItem}>
              <Text style={styles.bold}>Inspection Copy:</Text> Buyer to provide
              a full copy of inspection to seller.
            </Text>
          )}
          {tpi?.copyOfInspection ===
            CONTRACT_COPY_OF_INSPECTION.WITHHOLD_FULL_COPY && (
            <Text style={styles.listItem}>
              <Text style={styles.bold}>Inspection Copy:</Text> Buyer reserves
              right to withhold full copy of inspection from seller.
            </Text>
          )}

          {tpi?.presenceOption ===
            CONTRACT_INSPECTION_PRESENCE_OPTION.BE_PRESENT && (
            <Text style={styles.listItem}>
              <Text style={styles.bold}>Inspection Presence:</Text> Buyer to be
              present at time of inspection.
            </Text>
          )}
          {tpi?.presenceOption ===
            CONTRACT_INSPECTION_PRESENCE_OPTION.WAIVE_RIGHT && (
            <Text style={styles.listItem}>
              <Text style={styles.bold}>Inspection Presence:</Text> Buyer waives
              right to be present at time of inspection.
            </Text>
          )}

          {(tpi?.enableBuyerNegotiateReleaseDays ||
            tpi?.enableBuyerNegotiateCreditsPriceDays ||
            tpi?.enableBuyerNegotiateCreditsCostsDays) && (
            <Text style={styles.listItem}>
              <Text style={styles.bold}>Negotiation Rights Timeline:</Text>{' '}
              {tpi?.enableBuyerNegotiateReleaseDays
                ? `Release of contract up to ${
                    tpi?.buyerNegotiateReleaseDays ?? 0
                  } days. `
                : ''}
              {tpi?.enableBuyerNegotiateCreditsPriceDays
                ? `Credits to price up to ${
                    tpi?.buyerNegotiateCreditsPriceDays ?? 0
                  } days. `
                : ''}
              {tpi?.enableBuyerNegotiateCreditsCostsDays
                ? `Credits to costs up to ${
                    tpi?.buyerNegotiateCreditsCostsDays ?? 0
                  } days. `
                : ''}
            </Text>
          )}
        </View>
      )}
      {inspectionType === CONTRACT_INSPECTION_TYPE.GENERAL_INSPECTION ? (
        <>
          <GeneralInspection
            homeinspectionNegotiationDays={
              contract?.contingency?.homeinspectionNegotiationDays
            }
          />
        </>
      ) : inspectionType === CONTRACT_INSPECTION_TYPE.ADDITIONAL_INSPECTION ? (
        <>
          <GeneralInspection
            homeinspectionNegotiationDays={
              contract?.contingency?.homeinspectionNegotiationDays
            }
          />
          <AdditionalInspection
            additionalInspectionType={
              contract?.contingency?.additionalInspectionType
            }
            homeinspectionNegotiationDays={
              contract?.contingency?.homeinspectionNegotiationDays
            }
          />
        </>
      ) : (
        <>
          <View style={styles.list}>
            <Text style={styles.listItem}>
              This Contract is{' '}
              <Text style={styles.DangerText}>NOT contingent</Text> upon{' '}
              <Text style={styles.bold}>Buyer</Text> obtaining a satisfactory
              home inspection.
            </Text>
            <Text style={styles.listItem}>
              <Text style={styles.bold}>Buyer</Text> reserves the right to have
              a home inspection performed{' '}
              <Text style={styles.ClauseText}>at Buyer’s expense</Text>.
            </Text>
            <Text style={styles.listItem}>
              If <Text style={styles.bold}>Buyer</Text> elects to have a home
              inspection performed, access to the{' '}
              <Text style={styles.bold}>Property</Text> for said inspections is
              expected{' '}
              <Text style={styles.ClauseText}>with reasonable notice</Text> to{' '}
              <Text style={styles.ClauseText}>Seller’s Agent</Text>.
            </Text>
          </View>
        </>
      )}
    </View>
  );
};

export default HomeInspection;
